/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import PerPageList from 'components/grid/list/components/pagination/components/per-page';
import PagesList from 'components/grid/list/components/pagination/components/pages-list';
import { PaginationContainer } from 'components/grid/list/components/pagination/style';
import { noop } from 'lodash';

class Pagination extends React.Component<any> {
  static type = 'paginationComponent';

  static propTypes = {
    onPageChange: PropTypes.func,
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
    count: PropTypes.number,
    totalCount: PropTypes.number,
    size: PropTypes.string,
    render: PropTypes.func,
  };

  static defaultProps = {
    render: undefined,
    onPageChange: noop,
    totalPages: 0,
    currentPage: 1,
    count: 0,
    totalCount: 0,
    size: 'large',
  };

  render() {
    const { render, count } = this.props;

    if (render) {
      return render.call(this);
    }

    if (!count) {
      return null;
    }

    return (
      <PaginationContainer data-type="pagination">
        <PagesList {...this.props} />
        <PerPageList {...this.props} />
        {/*
          <Text>Total number of records: {totalCount}</Text>
        */}
      </PaginationContainer>
    );
  }
}

export default Pagination;
